"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _selectors = require("../../../../store/selectors");
var _actions = require("../../../../store/actions");
var _copy = _interopRequireDefault(require("./img/copy.svg"));
var _CopyBasketItemButton = _interopRequireDefault(require("./components/CopyBasketItemButton"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject; // import moment from 'moment';
// import SendBasketButton from './components/SendBasketButton';
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledLink = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    :hover {\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});
var BasketInfo = function BasketInfo(_ref) {
  var basketID = _ref.basketID;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
    t = _useTranslation.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getBasketById)(state, {
        basketID: basketID
      });
    }),
    shortUrl = _useSelector.shortUrl,
    fullUrl = _useSelector.fullUrl;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onCopyBasketToBuffer = (0, _react.useCallback)(function () {
    dispatch((0, _actions.copyBasketToBuffer)(basketID));
  }, [basketID, dispatch]);
  var basketURL = R.or(shortUrl, fullUrl);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.infoContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.infoTitle
  }, t('SEND_BASKET_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.linkWrapper
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    href: basketURL,
    rel: "noopener noreferrer",
    target: "_blank"
  }, basketURL), /*#__PURE__*/_react.default.createElement(_CopyBasketItemButton.default, {
    copyContent: basketURL
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.infoTitle
  }, t('COPY_BASKET_TITLE')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.copyButton,
    icon: _copy.default,
    theme: _Button.THEMES.GRAY,
    onClick: onCopyBasketToBuffer
  }, t('COPY_BUTTON')));
};
BasketInfo.propTypes = {
  basketID: _propTypes.default.number.isRequired
};
var _default = exports.default = (0, _react.memo)(BasketInfo);